import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Type, Loader2, ArrowLeft } from 'lucide-react';
import api from "../../../../api/axios";

const EditCategory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const [name, setName] = useState('');
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // Fetch existing data
  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const res = await api.get(`/categories`); // Or a specific /categories/${id} if you have it
        const cat = res.data.data.find(c => c.id === parseInt(id));
        if (cat) {
          setName(cat.name);
          setPreview(`${process.env.REACT_APP_BACKEND_URL}${cat.image}`);
        }
      } catch (err) {
        console.error("Error fetching category", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCategory();
  }, [id]);

  const handleFile = (file) => {
    if (file && file.type.startsWith('image/')) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    const formData = new FormData();
    formData.append('name', name);
    if (image) {
      formData.append('image', image);
    }
    
    // 🔥 IMPORTANT: Laravel needs this to treat POST as PUT when sending files
    formData.append('_method', 'POST'); 

    try {
      const response = await api.post(`/categories/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (response.data.success) {
        alert('Mise à jour réussie !');
        navigate('/admin/dashboard/categories'); // Adjust to your list route
      }
    } catch (error) {
      console.error("Update error", error);
      alert("Erreur lors de la modification.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-[#ffaa00]" size={40} /></div>;

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="max-w-2xl mx-auto p-6">
      <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-[#8A8A89] font-bold text-xs mb-6 uppercase tracking-widest hover:text-black">
        <ArrowLeft size={16} /> Retour
      </button>

      <div className="bg-white rounded-[2.5rem] shadow-xl p-8 border border-gray-100">
        <h2 className="text-xl font-black uppercase mb-6">Modifier la Catégorie</h2>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <label className="text-[10px] font-black uppercase tracking-widest text-[#8A8A89] ml-2">Nom</label>
            <div className="relative">
              <Type className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-300" size={18} />
              <input 
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full pl-12 pr-4 py-4 bg-gray-50 border-none rounded-2xl focus:ring-2 focus:ring-[#ffaa00] outline-none font-bold"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="text-[10px] font-black uppercase tracking-widest text-[#8A8A89] ml-2">Image</label>
            <div className="relative rounded-3xl overflow-hidden h-48 bg-gray-100 border border-gray-100 group">
              <img src={preview} alt="Preview" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                 <button 
                  type="button"
                  onClick={() => document.getElementById('editFile').click()}
                  className="bg-white text-black px-4 py-2 rounded-xl font-black text-[10px] uppercase"
                >
                  Changer l'image
                </button>
              </div>
              <input id="editFile" type="file" className="hidden" onChange={(e) => handleFile(e.target.files[0])} />
            </div>
          </div>

          <button 
            disabled={saving}
            type="submit"
            className="w-full py-5 bg-[#ffaa00] text-white rounded-2xl font-black uppercase tracking-widest text-xs flex items-center justify-center gap-2 hover:bg-black transition-all disabled:opacity-50"
          >
            {saving ? <Loader2 className="animate-spin" /> : 'Enregistrer les modifications'}
          </button>
        </form>
      </div>
    </motion.div>
  );
};

export default EditCategory;